import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { PhxContextService, PHOENIX_CONTEXTS, PhxSizeMapType } from './phx-context-service';

@Injectable()
export class PhxContainerComponentService extends PhxContextService {
  private readonly _sizeMap$ = new BehaviorSubject<PhxSizeMapType>({});

  public readonly sizeMap$: Observable<PhxSizeMapType> = this._sizeMap$.asObservable();

  public getType(): PHOENIX_CONTEXTS {
    return PHOENIX_CONTEXTS.CONTAINER_COMPONENT;
  }

  /**
   * Emits a new size map to all subscribed child components.
   * Keys are component selectors (e.g. 'phx-select'), values are PHX_SIZE constants.
   */
  public updateSizeMap(sizeMap: PhxSizeMapType): void {
    this._sizeMap$.next(sizeMap);
  }
}
